import React from "react";
import styled from "styled-components";
import { Chip, Grid } from "@mui/material";
import countries from "../../assets/locales/countries";

const ItemTitle = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const ItemValue = styled.span`
    font-size: 14px;
    font-weight: 700;
`;

const OrganisationalInfo = ({ profileData }) => {
    const [userCountry, setUserCountry] = React.useState();
    const [userRegion, setUserRegion] = React.useState();

    React.useEffect(() => {
        if (userCountry) {
            import(`src/assets/locales/regions/${userCountry.value}`).then((value) =>
                setUserRegion(
                    value.default.find((region) => region.value === profileData.location.region)
                )
            );
        } else {
            setUserRegion();
        }
    }, [userCountry]);

    React.useEffect(() => {
        if (profileData.location && profileData.location.country) {
            setUserCountry(
                countries.find((country) => country.value === profileData.location.country)
            );
        } else {
            setUserCountry();
        }
    }, [profileData.location && profileData.location.country]);

    const getWorkPreferences = () => {
        const selectedPreferences = profileData.workPreferences.filter(
            (workPreference) => workPreference.selected
        );
        return (
            <>
                {selectedPreferences.map((selectedPreference) => (
                    <Chip
                        label={selectedPreference.title}
                        variant="outlined"
                        key={selectedPreference.title}
                    />
                ))}
            </>
        );
    };

    return (
        <Grid container direction="row" spacing={3}>
            <Grid
                container
                item
                direction="column"
                spacing={1}
                style={{ width: "auto", minWidth: "50%" }}
            >
                <Grid item>
                    <ItemTitle>Seniority</ItemTitle>
                </Grid>
                <Grid item>
                    <ItemValue>{profileData.seniority}</ItemValue>
                </Grid>
            </Grid>
            <Grid
                container
                item
                direction="column"
                spacing={1}
                style={{ width: "auto", minWidth: "50%" }}
            >
                <Grid item>
                    <ItemTitle>Position</ItemTitle>
                </Grid>
                <Grid item>
                    <ItemValue>{profileData.jobTitle}</ItemValue>
                </Grid>
            </Grid>
            <Grid
                container
                item
                direction="column"
                spacing={1}
                style={{ width: "auto", minWidth: "50%" }}
            >
                <Grid item>
                    <ItemTitle>Working Hours Per Week</ItemTitle>
                </Grid>
                <Grid item>
                    <ItemValue>{profileData.workingHoursPerWeek}</ItemValue>
                </Grid>
            </Grid>

            <Grid
                container
                item
                direction="column"
                spacing={1}
                style={{ width: "auto", minWidth: "50%" }}
            >
                <Grid item>
                    <ItemTitle>Location</ItemTitle>
                </Grid>
                <Grid item>
                    <ItemValue>
                        {userCountry && userCountry.label}
                        {userRegion ? `, ${userRegion.label}` : ""}
                    </ItemValue>
                </Grid>
            </Grid>
            <Grid
                container
                item
                direction="column"
                spacing={1}
                style={{ width: "auto", minWidth: "50%" }}
            >
                <Grid item>
                    <ItemTitle>Work Preference</ItemTitle>
                </Grid>
                <Grid item>
                    <ItemValue>{getWorkPreferences()}</ItemValue>
                </Grid>
            </Grid>
            <Grid
                container
                item
                direction="column"
                spacing={1}
                style={{ width: "auto", minWidth: "50%" }}
            >
                <Grid item>
                    <ItemTitle>Website</ItemTitle>
                </Grid>
                <Grid item>
                    <ItemValue>{profileData.website}</ItemValue>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default OrganisationalInfo;
